<form [formGroup]="generalInfoForm" class="flex flex-col gap-y-3 max-w-[800px]">
  <div class="flex gap-4 items-center justify-center mt-3 mb-6">
    <div class="w-32 h-32 rounded-full flex justify-center items-center relative">
      <div class="w-32 h-32 relative overflow-hidden rounded-full">
        @if (isLoadingAvatar()) {
          <xemex-skeleton-block
            [width]="'128px'"
            [height]="'128px'"
            [borderRadius]="'50%'"
          ></xemex-skeleton-block>
        } @else {
          <img
            class="w-32 h-32 rounded-full absolute z-10"
            [src]="croppedImage ? croppedImage : 'assets/images/illustration/dummy-avatar.jpg'"
          />
        }
      </div>
      <div class="absolute z-20 bottom-0 right-0">
        <button
          type="button"
          mat-ripple
          class="p-2 flex rounded-full bg-primary"
          (click)="onUploadProfilePhoto()"
        >
          <mat-icon class="text-white">photo_camera</mat-icon>
        </button>
      </div>
    </div>
  </div>
  @if (isLoading()) {
    <div>
      <div class="lg:flex gap-x-10">
        <xemex-skeleton-block [height]="'57px'" class="w-full mb-2">
          <mat-label>{{ 'myProfile.tabs.info.content.firstName' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="firstName"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">person</mat-icon>
          @if (firstNameControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.firstName' | translate }
            }}</mat-error>
          }
        </xemex-skeleton-block>
        <xemex-skeleton-block [height]="'57px'" class="w-full mb-8">
          <mat-label>{{ 'myProfile.tabs.info.content.lastName' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="lastName"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">person</mat-icon>
          @if (lastNameControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.lastName' | translate }
            }}</mat-error>
          }
        </xemex-skeleton-block>
      </div>
      <div class="lg:flex gap-x-10">
        <xemex-skeleton-block [height]="'57px'" class="w-full mb-8">
          <mat-label>{{ 'myProfile.tabs.info.content.email' | translate }}</mat-label>
          <input
            type="email"
            matInput
            formControlName="email"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">mail</mat-icon>
          @if (emailControl.hasError('email') && !emailControl.hasError('required')) {
            <mat-error>{{ 'error.emailInvalid' | translate }}</mat-error>
          }
          @if (emailControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.email' | translate }
            }}</mat-error>
          }
        </xemex-skeleton-block>
        <xemex-skeleton-block [height]="'57px'" class="w-full mb-8">
          <mat-label>{{ 'myProfile.tabs.info.content.phone' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="phone"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">phone</mat-icon>
          @if (phoneControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.phone' | translate }
            }}</mat-error>
          }
        </xemex-skeleton-block>
      </div>
      <div class="lg:flex gap-x-10">
        <xemex-skeleton-block [height]="'57px'" class="w-full mb-8">
          <mat-label>{{ 'myProfile.tabs.info.content.language' | translate }}</mat-label>
          <mat-select
            formControlName="language"
            [placeholder]="'general.placeholderInput' | translate"
          >
            @for (language of LANGUAGES; track $index) {
              <mat-option [value]="language.code.toUpperCase()">
                {{ language.translationCode | translate }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix class="text-neutral">language</mat-icon>
          @if (languageControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.language' | translate }
            }}</mat-error>
          }
        </xemex-skeleton-block>
        <!-- <mat-form-field class="w-full">
        <mat-label>{{
          'myProfile.tabs.info.content.role' | translate
        }}</mat-label>
        <input
          type="text"
          matInput
          formControlName="role"
          [placeholder]="'general.placeholderInput' | translate" />
        <mat-icon matSuffix class="text-neutral">admin_panel_settings</mat-icon>
        @if (roleControl.hasError('required')) {
        <mat-error>{{
          'error.required'
            | translate
              : { field: 'myProfile.tabs.info.content.role' | translate }
        }}</mat-error>
        }
      </mat-form-field> -->
      </div>
    </div>
  } @else {
    <div>
      <div class="lg:flex gap-x-10">
        <mat-form-field class="w-full">
          <mat-label>{{ 'myProfile.tabs.info.content.firstName' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="firstName"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">person</mat-icon>
          @if (firstNameControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.firstName' | translate }
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>{{ 'myProfile.tabs.info.content.lastName' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="lastName"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">person</mat-icon>
          @if (lastNameControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.lastName' | translate }
            }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="lg:flex gap-x-10">
        <mat-form-field class="w-full">
          <mat-label>{{ 'myProfile.tabs.info.content.email' | translate }}</mat-label>
          <input
            type="email"
            matInput
            formControlName="email"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">mail</mat-icon>
          @if (emailControl.hasError('email') && !emailControl.hasError('required')) {
            <mat-error>{{ 'error.emailInvalid' | translate }}</mat-error>
          }
          @if (emailControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.email' | translate }
            }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="w-full">
          <mat-label>{{ 'myProfile.tabs.info.content.phone' | translate }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="phone"
            [placeholder]="'general.placeholderInput' | translate"
          />
          <mat-icon matSuffix class="text-neutral">phone</mat-icon>
          @if (phoneControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.phone' | translate }
            }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="lg:flex gap-x-10">
        <mat-form-field class="w-full">
          <mat-label>{{ 'myProfile.tabs.info.content.language' | translate }}</mat-label>
          <mat-select
            formControlName="language"
            [placeholder]="'general.placeholderInput' | translate"
          >
            @for (language of LANGUAGES; track $index) {
              <mat-option [value]="language.code.toUpperCase()">
                {{ language.translationCode | translate }}</mat-option
              >
            }
          </mat-select>
          <mat-icon matSuffix class="text-neutral">language</mat-icon>
          @if (languageControl.hasError('required')) {
            <mat-error>{{
              'error.required'
                | translate: { field: 'myProfile.tabs.info.content.language' | translate }
            }}</mat-error>
          }
        </mat-form-field>
        <!-- <mat-form-field class="w-full">
      <mat-label>{{
        'myProfile.tabs.info.content.role' | translate
      }}</mat-label>
      <input
        type="text"
        matInput
        formControlName="role"
        [placeholder]="'general.placeholderInput' | translate" />
      <mat-icon matSuffix class="text-neutral">admin_panel_settings</mat-icon>
      @if (roleControl.hasError('required')) {
      <mat-error>{{
        'error.required'
          | translate
            : { field: 'myProfile.tabs.info.content.role' | translate }
      }}</mat-error>
      }
    </mat-form-field> -->
      </div>
    </div>
  }
</form>
